// @ts-nocheck
import type { PageState } from 'src/@types'
import { Fragment, createElement, useRef, useEffect } from 'react'
import QRCode from 'qrcode.react'
import clsx from 'clsx'
import { LoginBox } from './login'
import { ForgetPassword } from './forgetPassword'
import { DenserPeriod } from './denserPeriod'
import { Button } from 'src/component'
import { CustomSlick } from './background'
import { usePageUtils } from './page.utils'
import { I18NS, PAGE_TYPE, getLocationParams, insertResource } from 'src/utils'
import s from './page.module.scss'

export const globalStore = {
  data: null
}

const { useCreate } = livecloud

function UrlDecode(str) {
  let ret = ''
  for (let i = 0; i < str.length; i++) {
    let chr = str.charAt(i)
    if (chr == '+') {
      ret += ' '
    } else if (chr == '%') {
      let asc = str.substring(i + 1, i + 3)
      if (parseInt('0x' + asc) > 0x7f) {
        ret += asc2str(parseInt('0x' + asc + str.substring(i + 4, i + 6)))
        i += 5
      } else {
        ret += asc2str(parseInt('0x' + asc))
        i += 2
      }
    } else {
      ret += chr
    }
  }
  return ret
}

export function RootPage({ isApp, pageType }) {

  const [ state, setState, getNewState ] = livecloud.useStates<PageState>(() => ({
    isInit:           true,
    isForgetPassword: pageType === PAGE_TYPE.ForgotPassword || false,
    // 多用户选择
    choseUser:        null,
    // 提示字体颜色
    warningWordColor: '#DEA01A'
  }))

  useCreate(async () => {
    const index = location.href.indexOf('?')
    const search = location.href.slice(index + 1)
    const tip = new URLSearchParams(search).get('tip')
    if (tip) {
      livecloud.tip.error(UrlDecode(tip))
    }
    initState()
  })

  const {
    initState,
    toggleLang,
    getQRCode,
    handleChoseLogin
  } = usePageUtils({ globalStore, setState, getNewState })

  const rootRef = useRef<HTMLDivElement>(null!)

  const { warningWordColor, choseUser, isForgetPassword, isInit, footerText, requestData, lang, qrCode, qrCodeMsg } = state

  useEffect(() => {
    if (isApp) {
      if (rootRef.current) {
        let x = document.body.clientWidth
        let y = document.body.clientHeight
        rootRef.current.style.width = `${x}px`
        rootRef.current.style.height = `${y}px`
        rootRef.current.style.position = 'fixed'
        rootRef.current.style.left = 0
        rootRef.current.style.top = 0
      }
    }
  }, [ isInit ])

  useEffect(() => {
    if (requestData?.suspensionsEnable) {
      livecloud.suspensionsContextPath = requestData?.suspensionsContextPath ?? livecloud.basename
      // 引入js
      insertResource({ css: [], script: [ requestData?.suspensionsUrl ] })
    }
  }, [ requestData ])

  if (isInit) return null

  const {
    supportLocales,
    qrcodeEnabled,
    iosDownloadUrl,
    appQrDownloadEnable,
    androidDownloadUrl,
    headerBackground,
    forgotPasswordEnabled,
    appUsers,
    clientName,
    imgs: {
      logoMid,
      logoTop,
      logoLeft,
      background,
      qrCodeBackground,
      mobileBackground,
      mobileLogo
    },
    position
  } = requestData

  //中英文组件
  const LanguageComponent = () => {
    return (
      supportLocales.map(({ lang: currentLang, name }, i) => (
        <Fragment key={currentLang}>
          <div
            className={clsx(currentLang === lang ? `${s.active} changLangActive ` : '', `${s.changLang} changLang`)}
            style={{ color: isApp ? (currentLang === lang ? 'var(--primary-main)' : '#666666') : '' }}
            onClick={() => toggleLang(currentLang)}
          >
            {name}
          </div>
          {i !== supportLocales.length - 1 && '/'}
        </Fragment>
      ))
    )
  }
  //是否绑定登录
  const isBindLogin = window.location.href.includes('&pageType=bindingLogin')
  //判断是否有多用户
  const { pageType: isMoreUserPage } = getLocationParams()

  return (
    <div ref={rootRef} className={`${s.root} ${isApp ? 'appRoot' : 'root'} b-fx b-j-c`} >
      {
        isApp || (
          <header className={clsx('b-fx b-j-sb', headerBackground || s.headerHide)}>
            <div className={`${s.logo} header-logo b-fx`}>
              <img src={`${livecloud.basename}${logoTop}`} />
              <span>
                {I18NS.UNI_AUTH_WORD}
              </span>
            </div>
            <div className={`${s.right} header-common b-fx`}>
              <LanguageComponent />
              {
                !isApp && appQrDownloadEnable && (
                  // !isApp && (
                  <div className={`${s.codeDownload} header-download b-rel b-fx`}>
                    <livecloud.icons.Icon
                      href='#LiveCloud-common-code'
                      size={17}
                    />
                    {I18NS.APP_DOWNLOAD}
                    <div className={`${s.downloadFloat} b-fx b-abs`}>
                      {
                        iosDownloadUrl && (
                          <div className='b-fx b-fx-col header-download-ios b-j-c'>
                            <QRCode
                              value={iosDownloadUrl}
                              size={100}
                              fgColor='#000000'
                            />
                            <div className={s.downText}>{I18NS.IOS_TEXT}</div>
                          </div>
                        )
                      }
                      {
                        androidDownloadUrl && (
                          <div className='b-fx b-fx-col header-download-android b-j-c'>
                            <QRCode
                              value={androidDownloadUrl}
                              size={100}
                              fgColor='#000000'
                            />
                            <div className={s.downText}>{I18NS.ANDROID_TEXT}</div>
                          </div>
                        )
                      }
                    </div>
                  </div>
                )
              }
            </div>
          </header>
        )
      }
      {isApp && <img src={`${livecloud.basename}${mobileLogo}`} className={`${s.AppLogo} app-logo`} />}
      {/* 中间盒子 */}
      <div
        className={`${s.centerBox} centerBox b-fx center`}
        style={{
          height:        isApp ? 'auto' : (lang === 'en' ? 550 : (isMoreUserPage === 'switchUser' ? 400 : 450)),
          flexDirection: logoLeft ? 'row-reverse' : 'row',
          marginRight:   position === 'left' ? 'auto' : 'unset',
          marginLeft:    position === 'right' ? 'auto' : 'unset'
        }}
      >
        {
          isMoreUserPage == 'switchUser' ?
            <div className={s.choseUserPage}>
              <div className={s.choseUserPageHead}>{I18NS.ACCOUNT_CHOOSE}</div>
              <div className={`${!isApp && 'b-ellipsis'} ${s.choseUserSub}`}>
                <div dangerouslySetInnerHTML={{ __html: `<div>${I18NS['ACCOUNT_TIP']?.replace('{0}', `<strong>${clientName}</strong>`)}</div>` }} />
              </div>
              <div className={`b-fx ${s.choseUserPageList}`}>
                {
                  appUsers?.map((t, i) => (
                    <div
                      key={t.id}
                      style={{ width: isApp ? '100%' : '25.25rem' }}
                      className={choseUser?.id === t.id && s.choseUserItem}
                      onClick={() => setState('choseUser', t)}
                    >
                      <div className={`b-fx ${s.moreUser}`}>
                        <livecloud.icons.SvgIcon
                          href='#LiveCloud-common-wancheng'
                          fill={choseUser?.id === t.id ? '#5DDA69' : '#E3E3E3'}
                          size={18}
                        />
                        <span>{t.userName}</span>
                      </div>
                      <div className={`b-ellipsis ${s.userId}`} title={t.userId}>
                        {I18NS.ACCOUNT}：{t.userId}
                      </div>
                    </div>
                  ))
                }
              </div>
              <Button onClick={() => handleChoseLogin(choseUser)} className={s.userLoginBtn}>
                {I18NS.CONFIRM}
              </Button>
            </div>
            :
            <>
              <div
                key={lang}
                className={`${s.loginBox} loginBox b-fx b-fx-col`}
                style={{
                  width: (lang === 'en' ? 550 : 500)
                }}
              >
                {!isApp &&
                  <>
                    {
                      isBindLogin ?
                        <div className={s.wxLoginTitle}>{I18NS.BIND_WX_TITLE}</div>
                        :
                        <img className={`${s.logo} center-logo`} src={`${livecloud.basename}${logoMid}`} />
                    }
                  </>
                }
                {
                  createElement(
                    isForgetPassword ? ForgetPassword : (pageType === PAGE_TYPE.DenserPeriod ? DenserPeriod : LoginBox),
                    { initState, setRootState: setState, requestData, isApp, pageType, getRootState: getNewState, LanguageComponent }
                  )
                }
                {
                  forgotPasswordEnabled && I18NS.WARNING_WORD && !isBindLogin && (
                    <div className={`${s.loginTip} loginTip`} style={{ color: warningWordColor }}>
                      <div className={`b-fx ${s.tipContent} tipContent`}>
                        <livecloud.icons.SvgIcon
                          className={s.icon}
                          href='LiveCloud-common-tishi1'
                          size={14}
                          fill={warningWordColor}
                        />
                        <div className='tipWord'>
                          <span>
                            {I18NS.WARNING_WORD}
                          </span>
                        </div>
                      </div>
                    </div>
                  )
                }
              </div>
              {/* 二维码 */}
              {
                !isApp && (
                  qrcodeEnabled ?
                    (
                      <div className={`${s.scanBox} scanBox b-rel b-fx b-j-c`}>
                        <div
                          className={`${s.bg} b-abs`}
                          style={{ backgroundImage: `url(${qrCodeBackground})` }}
                        />
                        <div className={`${s.scanBoxContent} scanBoxContent b-abs b-fx b-j-c b-fx-col`}>
                          <div className={`${s.code} scanBoxQrCode`} >
                            {
                              qrCodeMsg && (
                                <div className={`${s.codeMsgBg} scanBoxMsgBg`}>
                                  <div className={s.codeMsg}>
                                    <livecloud.icons.SvgIcon
                                      className={s.qrCodeMsgIcon}
                                      fill='#F55859'
                                      href='#LiveCloud-common-tishi'
                                      size={30}
                                    />
                                    <p className={`${s.codeMsgText} scanBoxMsg`}>
                                      {qrCodeMsg}
                                    </p>
                                    <p className={`${s.codeMsgTip} scanBoxTip`} onClick={getQRCode}>
                                      {I18NS.QR_CODE_REFRESH_WORD || '请刷新'}
                                    </p>
                                  </div>
                                </div>
                              )
                            }
                            <QRCode
                              className='scanBoxCanvas'
                              onClick={getQRCode} //点击二维码事件
                              value={qrCode} //value参数为生成二维码的链接 
                              size={130} //二维码的宽高尺寸 
                              fgColor='#000000' //二维码的颜色 
                            />
                          </div>
                          <p className={`${s.codeTip} scanBoxText b-fx b-fx-col`}>
                            <span>{I18NS.SCAN_QR_CODE_WORD}</span>
                          </p>
                        </div>
                      </div>
                    ) :
                    (
                      logoLeft && <div className={`${s.leftBg} leftBg`} style={{ backgroundImage: `url(${logoLeft})` }} />
                    )
                )

              }
            </>
        }
      </div>
      <CustomSlick background={isApp ? [ mobileBackground ] : background} />
      {
        isMoreUserPage !== 'switchUser' && !isApp &&
        (
          <footer>
            {
              footerText.map((t, i) => {
                return (
                  <p key={i} className='b-fx b-j-c footer-text-root'>
                    {
                      t.map((t, i) => {
                        return (
                          <span
                            key={i}
                            className='footer-text'
                            dangerouslySetInnerHTML={{ __html: t }}
                          />
                        )
                      })
                    }
                  </p>
                )
              })
            }
          </footer>
        )
      }
    </div >
  )
}
